import * as React from "react";
import ClipboardContainer from "components/common/ClipboardContainer";
import { IconButton } from "components/common";
const ClipboardIconButton = ({
  buttonTitle = void 0,
  className = void 0,
  disabled = void 0,
  onSuccess = void 0,
  text
}) => /* @__PURE__ */ React.createElement(ClipboardContainer, { text }, ({ copy }) => /* @__PURE__ */ React.createElement(
  IconButton,
  {
    className,
    name: "content_copy",
    iconType: "regular",
    disabled,
    title: buttonTitle,
    onClick: () => {
      copy();
      onSuccess == null ? void 0 : onSuccess();
    }
  }
));
export default ClipboardIconButton;
